// extracted by mini-css-extract-plugin
module.exports = {"container":"KauphollFeedLatest-module--container--2_JMl"};